module.exports = __webpack_public_path__ + "static/media/logo.ab9a6047.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 130
// module chunks = 1